<template>
  <el-dialog
    :visible="visible"
    title="交易订单收款风险提示书"
    center
    width="600px"
    @close="$emit('update:visible', false)"
  >
    <p class="f-14 c-6 lh-40 t-i2em">
      您在找钢网平台-收款规则页面设置的金额和比例将直接影响您在平台交易的订单收款，即客户打款金额只要超过您在本平台设置的单笔订单最大少收款金额和比例，订单即将自动完成收款。少收的款项将在实提后补退环节进行结算。
    </p>
    <p class="f-14 c-3 lh-40 f-b t-i2em">
      请您慎重考虑自身情况并合理的设置单笔订单最大少收款金额和单笔订单最大少收款比例，避免补退金额过大造成的应收风险。
    </p>
    <el-button slot="footer" type="primary" @click="$emit('update:visible', false)"
      >我知道了</el-button
    >
  </el-dialog>
</template>

<script>
export default {
  name: 'RiskReminderDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
